<template lang="pug">
    fragment
        // Arrow
        td
            expand-component(:class="{'expanded' : expanded}")

        // Business Name
        td {{ item.fullName }}

        // Status
        td
            user-status(:status="item.status")

        // Actions
        td.px-0.text-xs-right

            // User statistics button
            button-component.statisticsView(:action="statisticsView" color="primary" icon="insert_chart")

            // Edit user button
            button-component.edit(:action="edit" color="primary" icon="edit")

            // Delete user button
            button-component.delete(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import UserStatus from './UserStatus';
    import ButtonIcon from '~components/ButtonIcon';
    import ExpandIcon from '~components/ExpandIcon';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        components: {
            UserStatus,
            ExpandComponent: ExpandIcon,
            ButtonComponent: ButtonIcon
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        },
        computed: {
            ...mapGetters('auth', ['isChampion', 'isAdmin'])
        },
        methods: {
            ...mapActions('users', ['deleteAccount']),

            managerRole(role) {
                return role === 'instructor' ? 'I' : 'A';
            },

            /**
             * Edit business
             */
            edit() {
                this.$router.push({
                    name: 'dashboard.users.edit',
                    params: { id: this.item.id }
                });
            },
            /**
             * Edit business
             */
            statisticsView() {
                this.$router.push({
                    name: 'dashboard.statistics.by.user',
                    params: { id: this.item.id }
                });
            },

            /**
             * Delete business.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteAccount(this.item.id);

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .role
        width: 30px
        height: 30px
        border-radius: 30px
        background-color: rgba(255,255, 255, 0.2)
        text-align: center
        font-size: 22px

    .fullName
        max-width: 140px
        overflow: hidden
        text-overflow: ellipsis
</style>
